<template>
  <div class="box flap-long-word">
    <article class="level is-mobile is-marginless">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <button type="button" v-on:click="order_open_Edit">
            <b-icon icon="edit"></b-icon>
          </button>
        </div>
        <div class="level-item">
          <button type="button" v-on:click="order_open_Delete">
            <b-icon icon="trash" type="is-danger"></b-icon>
          </button>
        </div>
      </div>
    </article>
    <article class="columns is-mobile">
      <section class="column full-width">
        <p v-on:click="go_To_Product">{{ name }}</p>
      </section>
    </article>
    <article class="columns is-mobile">
      <section class="column is-one-third is-rightpadding-less">
        <p>開催日:</p>
      </section>
      <section class="column">
        <p>{{ date }}</p>
      </section>
    </article>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "ivent",
  props: {
    ivent: Object
  },
  data: function() {
    return {
      name: this.ivent.data().name,
      date: moment(this.ivent.data().date.toDate()).format("YYYY/MM/DD")
    };
  },
  methods: {
    // 親に対して編集画面を開くように命令
    order_open_Edit: function() {
      this.$store.dispatch("ivent/display_Edit", this.ivent);
      this.$emit("order_Open_Edit");
    },
    // 親に対して削除画面を開くように命令
    order_open_Delete: function() {
      this.$store.dispatch("ivent/display_Delete", this.ivent);
      this.$emit("order_Open_Delete");
    },
    // 商品画面に遷移させる
    go_To_Product: function() {
      this.$router.push({
        name: "Product_Home",
        params: { name: this.ivent.data().name, id: this.ivent.id }
      });
    }
  }
};
</script>
<style>
.is-rightpadding-less {
  padding-right: 0;
}

.is-leftpadding-less {
  padding-left: 0;
}
</style>
